import { render, staticRenderFns } from "./EditTaskActivityBoxDialog.vue?vue&type=template&id=3ba5120a&scoped=true"
import script from "./EditTaskActivityBoxDialog.vue?vue&type=script&lang=js"
export * from "./EditTaskActivityBoxDialog.vue?vue&type=script&lang=js"
import style0 from "./EditTaskActivityBoxDialog.vue?vue&type=style&index=0&id=3ba5120a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba5120a",
  null
  
)

export default component.exports